export { BtsHeroTakeoverSection } from './components/bts-hero-takeover-section';
export {
  type BtsHeroFormalDegreeKey,
  type BtsHeroHeadline,
  type BtsHeroVariant,
  BTS_HERO_COUPON_CODES,
  BTS_HERO_CTA_LABEL,
  BTS_HERO_DEGREE_APPLICATION_CHECKOUT_PATH,
  BTS_HERO_STRIKETHROUGH_IMAGE,
  BTS_HERO_SUBSCRIBER_CHECKOUT_PATH,
  getBtsHeroCheckoutHref,
} from './constants/bts-hero-content';
